module.exports = __webpack_public_path__ + "static/img/sport.4d1a868.png";


//////////////////
// WEBPACK FOOTER
// ./static/kfit/sport.png
// module id = SyDc
// module chunks = 1